export const dictMap = {
    'BOOL': [
      {
        dict_memoni: 'BOOL',
        dict_code: '0',
        dict_text: '否',
        dict_text_en: 'False'
      },
      {
        dict_memoni: 'BOOL',
        dict_code: '1',
        dict_text: '是',
        dict_text_en: 'True'
      }
    ],
    'GENDER': [
      {
        dict_memoni: 'GENDER',
        dict_code: '1',
        dict_text: '男',
        dict_text_en: 'Man'
      },
      {
        dict_memoni: 'GENDER',
        dict_code: '2',
        dict_text: '女',
        dict_text_en: 'Woman'
      }
    ],
    'STATE': [
      {
        dict_memoni: 'STATE',
        dict_code: '0',
        dict_text: '创建',
        dict_text_en: 'Create'
      },
      {
        dict_memoni: 'STATE',
        dict_code: '1',
        dict_text: '上架',
        dict_text_en: 'Online'
      },
      {
        dict_memoni: 'STATE',
        dict_code: '2',
        dict_text: '下架',
        dict_text_en: 'Offline'
      }
    ],
    'COUNTRY_CODE': [
      {
        dict_memoni: 'COUNTRY_CODE',
        dict_code: '86',
        dict_text: '中国',
        dict_text_en: 'China'
      }
    ],
    'LANGUAGE': [
      {
        dict_memoni: 'LANGUAGE',
        dict_code: 'zh_CN',
        dict_text: '中文',
        dict_text_en: 'Chinese'
      },
      {
        dict_memoni: 'LANGUAGE',
        dict_code: 'en_US',
        dict_text: '英语',
        dict_text_en: 'English'
      }
    ],
    'TIMEZONE': [
      {
        dict_memoni: 'TIMEZONE',
        dict_code: 'UTC+8',
        dict_text: '北京',
        dict_text_en: 'Beijing'
      }
    ],
    'API_VERSION': [
      {
        dict_memoni: 'API_VERSION',
        dict_code: '1.0.0.0',
        dict_text: '1.0.0.0',
        dict_text_en: '1.0.0.0'
      }
    ],
    'USER_SOURCE': [
      {
        dict_memoni: 'USER_SOURCE',
        dict_code: '0',
        dict_text: '系统',
        dict_text_en: 'System'
      },
      {
        dict_memoni: 'USER_SOURCE',
        dict_code: '1',
        dict_text: '其他',
        dict_text_en: 'Other'
      }
    ],
    'USER_OFFICER_TYPE': [
      {
        dict_memoni: 'USER_OFFICER_TYPE',
        dict_code: '1',
        dict_text: '主岗',
        dict_text_en: 'Primary'
      },
      {
        dict_memoni: 'USER_OFFICER_TYPE',
        dict_code: '2',
        dict_text: '兼任',
        dict_text_en: 'Slave'
      }
    ],
    'SYS_LOG_TYPE': [
      {
        dict_memoni: 'SYS_LOG_TYPE',
        dict_code: '0001',
        dict_text: '用户登录',
        dict_text_en: 'Userlogin'
      },
      {
        dict_memoni: 'SYS_LOG_TYPE',
        dict_code: '0002',
        dict_text: '用户登出',
        dict_text_en: 'Userlogout'
      },
      {
        dict_memoni: 'SYS_LOG_TYPE',
        dict_code: '0003',
        dict_text: '应用操作',
        dict_text_en: 'Appoperation'
      }
    ],
    'APP_TYPE': [
      {
        dict_memoni: 'APP_TYPE',
        dict_code: 'Web',
        dict_text: 'Web',
        dict_text_en: 'Web'
      },
      {
        dict_memoni: 'APP_TYPE',
        dict_code: 'Android',
        dict_text: 'Android',
        dict_text_en: 'Android'
      },
      {
        dict_memoni: 'APP_TYPE',
        dict_code: 'iOS',
        dict_text: 'iOS',
        dict_text_en: 'iOS'
      }
    ]
}
